import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import Router from './router/Router';
import { Translation } from 'react-i18next';

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Translation>{() => <Router />}</Translation>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
